<template>
  <main class="content">
      <div class="row u-wa">
          <h1>
              Walls
          </h1>
      </div>
      <div class="topBar u-wa u-fright">
          <div class="topBar--item_right">
              <router-link to="/walls/add" class="btn btn_blue">
                Add new wall
              </router-link>
          </div>
      </div>
      <div class="table">
          <div class="table--row table--row_header">

              <div class="table--col is-active" style="max-width:203px">
                  <div class="table--col-title">
                      Picture
                  </div>
              </div>
              <div v-bind:class="getSortClasses('name')" @click="sort('name')" style="max-width:255px">
                  <div class="table--col-title">
                      Name
                      <div class="table--col-arrows">
                          <svg class="table--col-arrow" height="5" viewbox="0 0 9 5" width="9" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z" fill-rule="nonzero">
                              </path>
                          </svg>
                          <svg class="table--col-arrow" height="5" viewbox="0 0 9 5" width="9" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z" fill-rule="nonzero">
                              </path>
                          </svg>
                      </div>
                  </div>
              </div>
              <div class="table--col" style="max-width:130px">
                  <div class="table--col-title">
                      City
                  </div>
              </div>
              <div v-bind:class="getSortClasses('basePricing')" @click="sort('basePricing')" style="max-width:150px">
                  <div class="table--col-title">
                      Basic pricing
                      <div class="table--col-arrows">
                          <svg class="table--col-arrow" height="5" viewbox="0 0 9 5" width="9" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z" fill-rule="nonzero">
                              </path>
                          </svg>
                          <svg class="table--col-arrow" height="5" viewbox="0 0 9 5" width="9" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z" fill-rule="nonzero">
                              </path>
                          </svg>
                      </div>
                  </div>
              </div>
              <div class="table--col" style="max-width:290px">
                  <div class="table--col-title">
                      Webcams
                      <div class="table--col-arrows">
                          <svg class="table--col-arrow" height="5" viewbox="0 0 9 5" width="9" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z" fill-rule="nonzero">
                              </path>
                          </svg>
                          <svg class="table--col-arrow" height="5" viewbox="0 0 9 5" width="9" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z" fill-rule="nonzero">
                              </path>
                          </svg>
                      </div>
                  </div>
              </div>
              <div class="table--col" style="max-width:194px">
              </div>
          </div>
          <div class="table--row" v-for="wall in walls">
              <div class="table--col" style="max-width:203px">
                  <div class="table--video table--video_picture" v-bind:style="{ 'background-image': 'url(' + wall.picture.url + '?api_key=' + $parent.api_key + ')' }">
                  </div>
              </div>
              <div class="table--col" style="max-width:255px">
                  <strong>
                      {{wall.name}}
                  </strong>
              </div>
              <div class="table--col" style="max-width:130px">
                  <strong>
                      {{wall.city.name}}
                  </strong>
              </div>
              <div class="table--col" style="max-width:150px">
                  <strong>
                      ${{parseFloat(wall.basePricing).toFixed(2)}}
                  </strong>
              </div>
              <div class="table--col" style="max-width:290px">
                  <strong v-for="webcam in wall.liveViews">
                      <a :href="webcam.originalLink" target="_blank">{{webcam.originalLink}}</a>
                  </strong>
              </div>
              <div class="table--col" style="max-width:194px">
                  <router-link :to="{ name: 'EditWalls', params: { id: wall.id }}" class="btn btn btn_blueLight">
                    More Info / Edit
                  </router-link>
              </div>
          </div>
      </div>
      <loading :visible.sync="loadingVisible"></loading>
  </main>
</template>
<script>
import * as ListResource from '../../mixins/listResource.mixin';
import Loading from '../Loading.vue'

export default {
  name: 'Walls',
  components: {Loading},
  mixins: [ListResource],
  data () {
    return {
      model: 'walls',
      resource: 'walls',
      walls: [],
      sortOrder: 'asc',
      sortAttribute: 'name'
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Walls.vue?0912d288